import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export type CreateFreePromotionErrorCode = 'GENERIC_ERROR' | 'NOT_ABLE' | 'NO_DATA';
type CreateFreePromotionErrorType = { code: CreateFreePromotionErrorCode; message: TranslationKey };

export const CREATE_FREE_PROMOTION_ERROR_MAP: Record<CreateFreePromotionErrorCode, CreateFreePromotionErrorType> = {
	GENERIC_ERROR: {
		code: 'GENERIC_ERROR',
		message: translationKey('corgi.petition.starter_dashboard.todays_tip.promotion_tip.response_options.error'),
	},
	NOT_ABLE: {
		code: 'NOT_ABLE',
		message: translationKey('corgi.petition.starter_dashboard.todays_tip.promotion_tip.response_options.not_able'),
	},
	NO_DATA: {
		code: 'NO_DATA',
		message: translationKey('corgi.petition.starter_dashboard.todays_tip.promotion_tip.response_options.no_data'),
	},
};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const createFreePromotionErrorCodes = Object.keys(CREATE_FREE_PROMOTION_ERROR_MAP) as ReadonlyArray<
	keyof typeof CREATE_FREE_PROMOTION_ERROR_MAP
>;
